import Guard from '@/services/middleware'

const DashLayout = () => import('@/layouts/DashLayout.vue')
const DashHome = () => import('@/views/dash/dashboard/home.vue')
const AppointmentsShell = () => import('@/views/dash/appointments/AppointmentsShell.vue')
const Appointments = () => import('@/views/dash/appointments/home.vue')
const AppointmentServices = () => import('@/views/dash/appointments/catalog/ServicesHome.vue')
const AppointmentService = () => import('@/views/dash/appointments/catalog/ServiceShow.vue')
const AppointmentCoupons = () => import('@/views/dash/appointments/catalog/CouponsHome.vue')

export default [
    {
        path: '/',
        component: DashLayout,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkPermission],
        children: [
            { path: '', name: 'dashboard.home', component: DashHome, meta: { title: 'Dashboard', permission: 2 } },

            {
                path: 'appointments',
                component: AppointmentsShell,
                children: [
                    { path: '', name: 'dash.appointments', component: Appointments, meta: { title: 'Agendamentos', permission: 2 } },
                    { path: 'servicos', name: 'dash.appointments.services', component: AppointmentServices, meta: { title: 'Serviços', permission: 2 } },
                    { path: 'servicos/:id(\\d+)', name: 'dash.appointments.services.show', component: AppointmentService, meta: { title: 'Serviço', permission: 2 } },
                    { path: 'cupons', name: 'dash.appointments.coupons', component: AppointmentCoupons, meta: { title: 'Cupons', permission: 2 } },
                ],
            },

        ],
    },
]